import * as Sentry from '@sentry/browser'
import { User } from '@features/auth/auth-client-adapter'
import { AnalyticsProvider } from '../core'
import { Effect } from 'effect'

export const SentryAnalyticsService: AnalyticsProvider = {
  trackUserIdentified(user: User) {
    return Effect.sync(() => {
      Sentry.setUser({ id: user.id, email: user.email })
    })
  },
  trackUserAnonymous() {
    return Effect.sync(() => {
      Sentry.setUser(null)
    })
  }
}
